import { IJob2, Job2Status } from "../../../redux/progress/job2/job2Interface";
import { IState } from "../../../redux/store";

export default function GetJobStatu(state: IState) {
    const props = {
        activeIndex: state.progress.modules.activeIndex,
        job2s: state.progress.job2s,
        modules: state.progress.modules.modules,
        mid: state.progress.params.mid as string | undefined,
        flowType: state.progress.params.flowType as string | undefined,
        progressSteps: state.progress.progressStep,
        fixSteps: state.progress.fixStep,
    };
    const module = props.modules[props.activeIndex];
    let job: IJob2 = {
        status: Job2Status.waiting,
        jobName: "",
        log: []
    };

    if (props.mid) {
        if (props.flowType) {
            const step = props.fixSteps.find((findStep) => {
                return findStep.mid === props.mid;
            })
            if (step) {
                job = {
                    status: step.status as number,
                    jobName: "",
                    log: []
                }
            }
        } else {
            const step = props.progressSteps.find((findStep) => {
                return findStep.mid === props.mid;
            })
            if (step) {
                job = {
                    status: step.status as number,
                    jobName: "",
                    log: []
                }
            }
        }

    } else if (module && props.job2s[module.PRO_MODULE_NAME]) {
        job = props.job2s[module.PRO_MODULE_NAME];
    }

    return job.status;
}